import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import axios from "axios";
import { GoPencil } from "react-icons/go";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Bounce, toast } from "react-toastify";

const Footer = () => {
  const [res, setRes] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [editMode1, setEditMode1] = useState(false);
  const [editMode2, setEditMode2] = useState(false);
  const [editMode3, setEditMode3] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditing1, setIsEditing1] = useState(false);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("hiedberg_admin_token");

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/footer/get`
      );
      setRes(result.data.data);
      console.log(result.data.data);
    } catch (error) {
      console.error("Error fetching no data", error);
    } finally {
      setLoading(false);
    }
  };

  const validationSchema1 = Yup.object({
    address: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required('Label is required'),
        street: Yup.string().required('Street is required'),
        city: Yup.string(),
        state: Yup.string().required('State is required'),
        country: Yup.string().required('Country is required'),
        phoneNumber: Yup.string().required('Phone Number is required'),
      })
    ),
  });
 
  const validationSchema3 = Yup.object({
    email: Yup.string().email("Invalid email").required("Email is required"),
  });
  const validationSchema4 = Yup.object({
    description: Yup.string().required("Description is required"),
  });
  const validationSchema5 = Yup.object({
    brands: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required("Name is required"),
        url: Yup.string().url("Enter a valid URL").required("URL is required"),
      })
    ),
  });
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      const previewURL = URL.createObjectURL(file);
      setLogoPreview(previewURL);
    }
  };
  const initialValues = {
    logo: res?.logo || "",
  };

  const initialValues1 = {
    address: res?.address || [],
  };


  const initialValues3 = {
    email: res?.email || "",
  };
  const initialValues4 = {
    description: res?.description || "",
  };
  const initialValues5 = {
    brands: [
      {
        name: res?.brand?.[0]?.name || "",
        url: res?.brand?.[0]?.url || "",
      },
      {
        name: res?.brand?.[1]?.name || "",
        url: res?.brand?.[1]?.url || "",
      },
      {
        name: res?.brand?.[2]?.name || "",
        url: res?.brand?.[2]?.url || "",
      },
    ],
  };

  const handleSubmit = async () => {
    if (!logoFile) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", logoFile);
    try {
      const uploadRes = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const uploadedPath = uploadRes?.data?.data?.publicUrl;
      if (!uploadedPath) return;
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/company/update`,
        {
          logo: uploadedPath,
          address: res?.address || "",
          phone: res?.phone || "",
          email: res?.email || "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRes((prev) => ({ ...prev, logo: uploadedPath }));
      setEditMode(false);
      setLogoFile(null);
      setLogoPreview("");
      fetchData();
      toast.success("Logo updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (err) {
      toast.error(err, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Upload/update failed:", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit1 = async (values) => {
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/company/update`,
        {
          address: values.address,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEditMode1(false);
      fetchData();
      toast.success("Address updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Address update failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit3 = async (values) => {
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/company/update`,
        {
          email: values.email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setEditMode3(false);
      fetchData();
      toast.success("email updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Email update failed:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleFormSubmit4 = async (values) => {
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/footer/update`,
        {
          description: values.description,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setIsEditing(false);
      fetchData();
      toast.success("Description updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error(
        "Description update failed:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit5 = async (values) => {
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/footer/update`,
        {
          brands: values.brands,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setIsEditing1(false);
      fetchData();
      toast.success("Brands updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error(
        "Brands update failed:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {loading ? (
        <div className="flex justify-center py-10">
          <div className="h-6 w-6 animate-spin rounded-full border-t-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="mt-5 space-y-4 overflow-auto pb-6">
          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="mb-4 flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-800">Logo</h3>

                {editMode ? (
                  <div className="flex items-center gap-3">
                    <button
                      type="submit"
                      className="text-sm font-medium text-blue-600 hover:text-blue-800"
                    >
                      Save Changes
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setEditMode(false);
                        setLogoFile(null);
                        setLogoPreview("");
                      }}
                      className="text-sm font-medium text-gray-500 hover:text-gray-700"
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <GoPencil
                    className="hover:text-black h-5 w-5 cursor-pointer"
                    onClick={() => setEditMode(true)}
                  />
                )}
              </div>

              <div className="flex flex-col gap-y-4">
                <div className="group relative w-auto rounded-xl border border-gray-300 bg-white p-2 shadow-sm">
                  <img
                    src={logoPreview || `${res?.logo}`}
                    alt="logo"
                    className=" rounded-lg "
                  />
                  {editMode && (
                    <>
                      <div
                        className="bg-black absolute inset-0 flex cursor-pointer items-center justify-center rounded-lg bg-opacity-40 opacity-0 transition-opacity group-hover:opacity-100"
                        onClick={() =>
                          document.getElementById("logo-input").click()
                        }
                      >
                        <GoPencil className="h-5 w-5 text-white" />
                      </div>

                      <input
                        id="logo-input"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handleImageChange}
                      />
                    </>
                  )}
                </div>
              </div>
            </form>
          </div>

          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <Formik
              initialValues={initialValues1}
              validationSchema={validationSchema1}
              enableReinitialize
              onSubmit={handleSubmit1}
            >
              {({ values, errors, touched, handleChange, resetForm }) => (
                <Form>
                  <div className="mb-4 flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Address
                    </h3>

                    {editMode1 ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setEditMode1(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setEditMode1(true)}
                      />
                    )}
                  </div>

                  <div className="space-y-6">
                    {values.address.map((addressItem, index) => (
                      <div key={index} className="border border-gray-200 rounded-lg p-4 ">
                        <h4 className="text-md font-semibold text-gray-700 mb-4">
                          Address {index + 1}
                        </h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                          <TextField
                            label="Label"
                            name={`address[${index}].label`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={addressItem.label || ''}
                            onChange={handleChange}
                            disabled={!editMode1}
                            error={touched.address?.[index]?.label && Boolean(errors.address?.[index]?.label)}
                            helperText={touched.address?.[index]?.label && errors.address?.[index]?.label}
                          />
                          <TextField
                            label="Street"
                            name={`address[${index}].street`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={addressItem.street || ''}
                            onChange={handleChange}
                            disabled={!editMode1}
                            error={touched.address?.[index]?.street && Boolean(errors.address?.[index]?.street)}
                            helperText={touched.address?.[index]?.street && errors.address?.[index]?.street}
                          />
                          <TextField
                            label="City"
                            name={`address[${index}].city`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={addressItem.city || ''}
                            onChange={handleChange}
                            disabled={!editMode1}
                            error={touched.address?.[index]?.city && Boolean(errors.address?.[index]?.city)}
                            helperText={touched.address?.[index]?.city && errors.address?.[index]?.city}
                          />
                          <TextField
                            label="State"
                            name={`address[${index}].state`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={addressItem.state || ''}
                            onChange={handleChange}
                            disabled={!editMode1}
                            error={touched.address?.[index]?.state && Boolean(errors.address?.[index]?.state)}
                            helperText={touched.address?.[index]?.state && errors.address?.[index]?.state}
                          />
                          <TextField
                            label="Country"
                            name={`address[${index}].country`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={addressItem.country || ''}
                            onChange={handleChange}
                            disabled={!editMode1}
                            error={touched.address?.[index]?.country && Boolean(errors.address?.[index]?.country)}
                            helperText={touched.address?.[index]?.country && errors.address?.[index]?.country}
                          />
                          <TextField
                            label="Phone Number"
                            name={`address[${index}].phoneNumber`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={addressItem.phoneNumber || ''}
                            onChange={handleChange}
                            disabled={!editMode1}
                            error={touched.address?.[index]?.phoneNumber && Boolean(errors.address?.[index]?.phoneNumber)}
                            helperText={touched.address?.[index]?.phoneNumber && errors.address?.[index]?.phoneNumber}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </Form>
              )}
            </Formik>
          </div>

      

          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <Formik
              initialValues={initialValues3}
              validationSchema={validationSchema3}
              enableReinitialize
              onSubmit={handleSubmit3}
            >
              {({ values, errors, touched, handleChange, resetForm }) => (
                <Form>
                  <div className="mb-4 flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Email
                    </h3>
                    {editMode3 ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setEditMode3(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setEditMode3(true)}
                      />
                    )}
                  </div>
                  <TextField
                    label="Email"
                    name="email"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={values.email}
                    onChange={handleChange}
                    disabled={!editMode3}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    inputProps={{
                      maxLength: 100,
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                </Form>
              )}
            </Formik>
          </div>

          <Formik
            enableReinitialize
            initialValues={initialValues4}
            validationSchema={validationSchema4}
            onSubmit={handleFormSubmit4}
          >
            {({ errors, touched, handleChange, values, resetForm }) => (
              <Form>
                <div className="gap-y-4 rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                  <div className="flex justify-between">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Description
                    </h3>
                    {isEditing ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setIsEditing(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setIsEditing(true)}
                      />
                    )}
                  </div>
                  <div>
                    <TextField
                      name="description"
                      label="Description"
                      variant="outlined"
                      size="small"
                      fullWidth
                      slotProps={{ inputLabel: { shrink: true } }}
                      value={values.description}
                      onChange={handleChange}
                      disabled={!isEditing}
                      error={touched.description && Boolean(errors.description)}
                      helperText={touched.description && errors.description}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>

          <Formik
            enableReinitialize
            initialValues={initialValues5}
            validationSchema={validationSchema5}
            onSubmit={handleSubmit5}
          >
            {({ values, handleChange, errors, touched, resetForm }) => (
              <Form>
                <div className="mt-5 rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                  <div className="flex items-center justify-between">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Brand's Section
                    </h3>

                    {isEditing1 ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setIsEditing1(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setIsEditing1(true)}
                      />
                    )}
                  </div>
                  <div className="flex flex-col gap-y-4">
                    {values.brands.map((brand, index) => (
                      <div
                        key={index}
                        className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm"
                      >
                        <div className="mb-3">
                          <TextField
                            name={`brands[${index}].name`}
                            label="Name"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={brand.name}
                            onChange={handleChange}
                            disabled={!isEditing1}
                            error={
                              touched.brands?.[index]?.name &&
                              Boolean(errors.brands?.[index]?.name)
                            }
                            helperText={
                              touched.brands?.[index]?.name &&
                              errors.brands?.[index]?.name
                            }
                            InputLabelProps={{ shrink: true }}
                          />
                        </div>
                        <TextField
                          name={`brands[${index}].url`}
                          label="URL"
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={brand.url}
                          onChange={handleChange}
                          disabled={!isEditing1}
                          error={
                            touched.brands?.[index]?.url &&
                            Boolean(errors.brands?.[index]?.url)
                          }
                          helperText={
                            touched.brands?.[index]?.url &&
                            errors.brands?.[index]?.url
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}
    </>
  );
};

export default Footer;
